var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightRedChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E50B20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4286,
    height: 15.4286,
    transform: "translate(4.14453 19.7148) rotate(-90)",
    fill: "#E50B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71557 17.5195C9.39124 17.1952 9.36176 16.6877 9.62711 16.3301L9.71557 16.2276L13.9414 12.0014L9.71557 7.77518C9.39124 7.45085 9.36176 6.94334 9.62711 6.58571L9.71557 6.48325C10.0399 6.15892 10.5474 6.12944 10.905 6.3948L11.0075 6.48325L15.8797 11.3554C16.204 11.6798 16.2335 12.1873 15.9681 12.5449L15.8797 12.6474L11.0075 17.5195C10.6507 17.8763 10.0723 17.8763 9.71557 17.5195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRedChevron);
export default __webpack_public_path__ + "static/media/right-red-chevron.ed31748ce8d50d530fea9ec4ca8bce47.svg";
export { ForwardRef as ReactComponent };